/* eslint-disable no-unused-expressions */
import withAdminDashboard from "../../../HOC/withAdminDashboard";
import withActivityLayout from "../../../../../components/Common/HOC/withActivityLayout";
import procurementAPI from "../../../../../redux/api/procurementAPI";

const DraftBidding = () => (
  withActivityLayout(() => null)({
    postAPI: procurementAPI.savePlanDocument,
    getAPI: procurementAPI.getPlanDocuments,
    title: "Draft Bidding Documents",
    extraCrumbs: [
      {
        url: "#",
        title: "Draft Bidding Documents",
      },
    ]
  })
);

export default withAdminDashboard(DraftBidding);
